import React from "react"
import {findDOMNode} from "react-dom"
import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll";
import Popover from "../../../../../gd-components/gd-popover/popover-v2";
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position";
import FieldProto from "../../../../proto/field-proto";
import ModelEntity from "../../../../../model2/model-entity";
import AddressPopoverOptionsSelector from "./popover-options-selector";
import {FieldPopoverMenuProps} from "../../../dropdown/components/popover/popover-menu";

const debug = false
// const debug = "FieldAddress_PopoverMenu"

// export type FieldPopoverMenuProps = {
//     parent  : any,
//     field   : FieldProto,
//     model?  : ModelEntity
// }

export default class FieldAddress_PopoverMenu extends React.Component<FieldPopoverMenuProps,any> {

    public optionsSelector  : any
    public scroll           : any

    constructor(props:FieldPopoverMenuProps) {
        super(props)

        this.state = {
            searchString: null
        }
    }

    onPopoverKeyDown = (e:React.SyntheticEvent) => {if(this.optionsSelector) this.optionsSelector.onPopoverKeyDown(e)}

    onSearchChange = (newSearchString:string) => {
        this.setState({
            searchString: newSearchString
        })
    }

    updateScroll = (node:any, isCentered = false) => {
        debug && console.log(debug, "updateScroll", node, isCentered, this.scroll)

        if (!node || !this.scroll) return

        const scrollNode:any = findDOMNode(this.scroll.childrenContainer)
        const nodeTop       = node.offsetTop
        const nodeBottom    = node.offsetTop + node.offsetHeight
        const scrollTop     = scrollNode.scrollTop
        const scrollBottom  = scrollNode.scrollTop + scrollNode.offsetHeight

        debug && console.log(debug, "updateScroll", scrollBottom < nodeBottom, scrollTop > nodeTop)

        // ensure node to be in visible area of scroll
        if (isCentered)                     this.scroll.setScrollTop((nodeTop + nodeBottom) / 2, true, 0)
        else if (scrollBottom < nodeBottom) this.scroll.setScrollTop(nodeBottom - scrollNode.offsetHeight, false, 100)
        else if (scrollTop > nodeTop)       this.scroll.setScrollTop(nodeTop, false, 100)
    }

    render() {
        const isManager = gd.ac.check.company.isManager()

        const PopoverMenuMore = _.get(this.props.field.components, 'PopoverMenuMore', false)

        return (
            <Popover position          = {new PopoverPosition({attachment: "top center", targetAttachment: "bottom center"})}
                     getTargetFunc      = {()=>findDOMNode(this.props.parent)}
                     onKeyDown          = {this.onPopoverKeyDown}
                     onClickOutside     = {()=>{this.props.parent.hidePopover()}}>

                <div className={Classes("ui5-popover-menu", this.props.field.classes.PopoverMenu, {'with-help': isManager && PopoverMenuMore})}>
                    <VScroll ref                = {(r:any)=>this.scroll = r}
                             className          = "max-h-400 max-w-400"
                             minDragHeight      = {20}
                             containerClass     = {this.props.field.classes.PopoverMenuScrollContainer}
                             scrollVisibility   = "auto">

                        <AddressPopoverOptionsSelector  ref             = {(r:any)=>this.optionsSelector = r}
                                                        {...this.props}
                                                        searchString    = {this.state.searchString}
                                                        onUpdateScroll  = {this.updateScroll}/>
                    </VScroll>

                </div>
            </Popover>
        )
    }
}
